var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{staticClass:"logo-icon",attrs:{"src":require("@/static/invoice_logo_new.png"),"alt":"invoice_logo.png"}}),_c('span',{staticClass:"app-name"},[_vm._v("Swift Invoice")])])
}]

export { render, staticRenderFns }